









































































import { Vue, Component } from 'vue-property-decorator';
import AuditTimeline from '@/components/audit/AuditTimeline.vue';
import { CustomerInfo } from '@/core/userinfo';
import { getUserInfo } from '@/store/plugins/userInfoPlugin';
import idealName from '@/utils/ideal-name';
import capitalize from '@/utils/text';
import {
    AUDIT_ACTIONS,
    AuditEntry,
    fetchAuditLogs,
    fetchQueueAuditLogs,
} from '@/api/audit';

const PAGE_SIZE = 100;

@Component({ components: { AuditTimeline } })
export default class Audit extends Vue {
    customers: CustomerInfo[] = [];

    customerId = 0;

    action = '';

    queueName = '';

    entries: AuditEntry[] = [];

    isLoading = false;

    error = '';

    reachedEnd = false;

    actionOptions = AUDIT_ACTIONS;

    get hasManyCustomers(): boolean {
        return this.customers.length > 1;
    }

    get canLoadMore(): boolean {
        return !this.isLoading && !this.reachedEnd && this.entries.length > 0;
    }

    get queueDisplayName(): string {
        return capitalize(idealName(this.queueName));
    }

    mounted() {
        const userInfo = getUserInfo();
        this.customers = userInfo?.customers || [];
        this.customerId = this.currentCustomerId(userInfo?.currentDomain || '');
        this.queueName = String(this.$route.query.queueName || '');

        this.reload();
    }

    clearQueueFilter() {
        this.queueName = '';
        this.reload();
    }

    reload() {
        this.entries = [];
        this.reachedEnd = false;
        this.load();
    }

    loadMore() {
        this.load();
    }

    private async load() {
        if (this.customerId === 0) {
            this.error = String(this.$t('audit_no_customer'));
            return;
        }

        this.isLoading = true;
        this.error = '';

        try {
            const page = await this.requestPage();
            this.entries = this.entries.concat(page);
            this.reachedEnd = page.length < PAGE_SIZE;
        } catch (err) {
            this.error = String(this.$t('audit_load_error'));
        } finally {
            this.isLoading = false;
        }
    }

    private requestPage(): Promise<AuditEntry[]> {
        const beforeId = this.oldestLoadedId();

        if (this.queueName) {
            return fetchQueueAuditLogs({
                customerId: this.customerId,
                queueName: this.queueName,
                limit: PAGE_SIZE,
                beforeId,
            });
        }

        return fetchAuditLogs({
            customerId: this.customerId,
            limit: PAGE_SIZE,
            beforeId,
            actions: this.action ? [this.action] : undefined,
        });
    }

    // The list is newest first, so the cursor is the id of the last row already loaded.
    private oldestLoadedId(): number | undefined {
        const last = this.entries[this.entries.length - 1];

        return last?.id ?? undefined;
    }

    private currentCustomerId(currentDomain: string): number {
        const customer = this.customers.find((item) => item.domain === currentDomain);

        return customer?.id || this.customers[0]?.id || 0;
    }
}
